import { createTimer as J, SchemaReady as m, commandsCtx as g, commandsTimerCtx as Q, inputRulesCtx as O, editorStateTimerCtx as R, ThemeReady as k, marksCtx as v, schemaCtx as h, schemaTimerCtx as b, nodesCtx as C, prosePluginsCtx as f, InitReady as P, remarkPluginsCtx as E, nodeViewCtx as S, markViewCtx as A, editorViewTimerCtx as W, themeManagerCtx as I, emotionCtx as X, editorViewCtx as p, serializerCtx as Y, parserCtx as K, editorStateOptionsCtx as Z } from "@milkdown/core";
import { customAlphabet as _ } from "nanoid";
import { missingMarkInSchema as z, missingNodeInSchema as V, themeMustInstalled as U } from "@milkdown/exception";
import { keymap as j } from "@milkdown/prose/keymap";
import { NodeType as q, DOMSerializer as x, Slice as B } from "@milkdown/prose/model";
import { EditorState as ee } from "@milkdown/prose/state";
const F = (a) => Object.prototype.hasOwnProperty.call(a, "origin");
class G extends Array {
  findThenRun(n, e) {
    const s = this.findIndex((t) => F(t) && t.origin === n);
    return s < 0 ? this : (e(s), this);
  }
  configure(n, e) {
    return this.findThenRun(n, (s) => {
      this.splice(s, 1, n(e));
    });
  }
  replace(n, e) {
    return this.findThenRun(n, (s) => {
      this.splice(s, 1, e);
    });
  }
  remove(n) {
    return this.findThenRun(n, (e) => {
      this.splice(e, 1);
    });
  }
  headless() {
    return this.filter(F).forEach((n) => {
      this.configure(n.origin, { headless: !0 });
    }), this;
  }
  static create(n) {
    return new G(...n);
  }
}
const te = _("abcedfghicklmn", 10), y = (a, n, e) => {
  const s = J(e || te());
  let t = !1;
  const i = () => async (r) => {
    const o = () => {
      r.done(s), t = !0;
    };
    r.update(n, (c) => c.concat(s)), await a(r, i, o), t || r.done(s);
  };
  return i.timer = s, i;
}, we = (a) => {
  const n = () => async (e) => {
    await e.wait(m);
    const [s, t] = a(e);
    e.get(g).create(s, t), n.run = (i) => e.get(g).call(s, i), n.key = s;
  };
  return n;
}, le = (a, n) => y(async (e, s) => {
  await e.wait(m);
  const [t, i] = await a(e);
  e.get(g).create(t, i), s.run = (r) => e.get(g).call(t, r), s.key = t;
}, Q, n), he = (a) => {
  const n = () => async (e) => {
    await e.wait(m);
    const s = a(e);
    e.update(O, (t) => [...t, s]), n.inputRule = s;
  };
  return n;
}, pe = (a, n) => y(async (e, s) => {
  await e.wait(m);
  const t = await a(e);
  e.update(O, (i) => [...i, t]), s.inputRule = t;
}, R, n), ye = (a, n) => {
  const e = () => async (s) => {
    await s.wait(k);
    const t = n(s);
    s.update(v, (r) => [...r, [a, t]]), e.id = a, e.schema = t, await s.wait(m);
    const i = s.get(h).marks[a];
    if (!i)
      throw z(a);
    e.type = i;
  };
  return e;
}, ge = (a, n, e) => y(async (s, t, i) => {
  await s.wait(k);
  const r = await n(s);
  s.update(v, (c) => [...c, [a, r]]), t.id = a, t.schema = r, i(), await s.wait(m);
  const o = s.get(h).marks[a];
  if (!o)
    throw z(a);
  t.type = o;
}, b, e), fe = (a, n) => {
  const e = () => async (s) => {
    await s.wait(k);
    const t = n(s);
    s.update(C, (r) => [...r, [a, t]]), e.id = a, e.schema = t, await s.wait(m);
    const i = s.get(h).nodes[a];
    if (!i)
      throw V(a);
    e.type = i;
  };
  return e;
}, ke = (a, n, e) => y(async (s, t, i) => {
  await s.wait(k);
  const r = await n(s);
  s.update(C, (c) => [...c, [a, r]]), t.id = a, t.schema = r, i(), await s.wait(m);
  const o = s.get(h).nodes[a];
  if (!o)
    throw V(a);
  t.type = o;
}, b, e), ve = (a) => {
  const n = () => async (e) => {
    await e.wait(m);
    const s = a(e);
    e.update(f, (t) => [...t, s]), n.plugin = s;
  };
  return n;
}, Ce = (a, n) => y(async (e, s) => {
  await e.wait(m);
  const t = await a(e);
  e.update(f, (i) => [...i, t]), s.plugin = t;
}, R, n), Te = (a) => {
  const n = () => async (e) => {
    await e.wait(P);
    const s = a(e);
    e.update(E, (t) => [...t, s]), n.plugin = s;
  };
  return n;
}, Se = (a, n) => y(async (e, s) => {
  await e.wait(P);
  const t = await a(e);
  e.update(E, (i) => [...i, t]), s.plugin = t;
}, b, n), Ae = (a) => {
  const n = () => async (e) => {
    await e.wait(m);
    const s = a(e);
    e.update(f, (t) => [...t, j(s)]), n.keymap = s;
  };
  return n;
}, $e = (a, n) => y(async (e, s) => {
  await e.wait(m);
  const t = await a(e);
  e.update(f, (i) => [...i, j(t)]), s.keymap = t;
}, R, n), Me = (a, n) => {
  const e = () => async (s) => {
    await s.wait(m);
    const t = n(s);
    a.type instanceof q ? s.update(S, (i) => [...i, [a.id, t]]) : s.update(A, (i) => [...i, [a.id, t]]), e.view = t, e.type = a;
  };
  return e;
}, Oe = (a, n, e) => y(async (s, t) => {
  await s.wait(m);
  const i = await n(s);
  a.type instanceof q ? s.update(S, (r) => [...r, [a.id, i]]) : s.update(A, (r) => [...r, [a.id, i]]), t.view = i, t.type = a;
}, W, e), ne = (a) => (n, ...e) => {
  var t;
  const s = (t = a == null ? void 0 : a(n, ...e)) != null ? t : e;
  return Array.isArray(s) ? s.filter((i) => i).join(" ") : s;
}, Re = (a, n, e) => [a, n, e], L = (a, n) => {
  try {
    const e = a.get(I), s = a.get(X);
    if (!s.css)
      throw U();
    return {
      getClassName: ne(n == null ? void 0 : n.className),
      getStyle: (t) => n != null && n.headless ? "" : t(s),
      themeManager: e
    };
  } catch {
    throw U();
  }
}, N = async (a, n, e, s) => {
  if (await a.wait(P), n.remarkPlugins) {
    const i = n.remarkPlugins(a);
    a.update(E, (r) => [...r, ...i]);
  }
  const t = await e();
  if (n.commands && n.commands(t, a).forEach(([r, o]) => {
    a.get(g).create(r, o);
  }), n.inputRules) {
    const i = n.inputRules(t, a);
    a.update(O, (r) => [...r, ...i]);
  }
  if (n.shortcuts) {
    const i = (o, c) => {
      var u, d;
      return (d = (u = s == null ? void 0 : s.keymap) == null ? void 0 : u[o]) != null ? d : c;
    }, r = Object.entries(n.shortcuts).flatMap(([o, [c, u, d]]) => {
      const w = () => a.get(g).call(c, d), T = i(o, u);
      return Array.isArray(T) ? T.map((l) => ({ key: l, runner: w })) : { key: T, runner: w };
    }).map((o) => [o.key, o.runner]);
    a.update(f, (o) => o.concat(j(Object.fromEntries(r))));
  }
  if (n.prosePlugins) {
    const i = n.prosePlugins(t, a);
    a.update(f, (r) => [...r, ...i]);
  }
}, D = (a) => {
  const n = (e) => {
    const s = a(e);
    return s.origin = n, s;
  };
  return n;
}, H = (a, n, e) => {
  const s = n, t = (i, r) => e((...o) => i(a(...o), ...o), r);
  return s.extend = t, s;
}, ae = (a, n) => H(a, D((e) => (s) => (n == null || n.forEach((t) => s.inject(t)), async (t) => {
  var o;
  await t.wait(k);
  const i = L(t, e), r = a(i, e);
  if (r.view = (o = e == null ? void 0 : e.view) != null ? o : r.view, await N(t, r, async () => {
    const c = r.schema(t);
    t.update(v, (w) => [...w, [r.id, c]]), await t.wait(m);
    const d = t.get(h).marks[r.id];
    if (!d)
      throw z(r.id);
    return d;
  }, e), r.view) {
    const c = r.view(t);
    t.update(A, (u) => [...u, [r.id, c]]);
  }
})), ae), se = (a, n) => H(a, D((e) => (s) => (n == null || n.forEach((t) => s.inject(t)), async (t) => {
  var o;
  await t.wait(k);
  const i = L(t, e), r = a(i, e);
  if (r.view = (o = e == null ? void 0 : e.view) != null ? o : r.view, await N(t, r, async () => {
    const c = r.schema(t);
    t.update(C, (w) => [...w, [r.id, c]]), await t.wait(m);
    const d = t.get(h).nodes[r.id];
    if (!d)
      throw V(r.id);
    return d;
  }, e), r.view) {
    const c = r.view(t);
    t.update(S, (u) => [...u, [r.id, c]]);
  }
})), se), re = (a, n) => H(a, D((e) => (s) => (n == null || n.forEach((t) => s.inject(t)), async (t) => {
  await t.wait(k);
  const i = L(t, e), r = a(i, e);
  if (await N(t, r, async () => {
    let o = {}, c = {};
    if (r.schema) {
      const l = r.schema(t);
      if (l.node) {
        o = l.node;
        const $ = Object.entries(l.node);
        t.update(C, (M) => [...M, ...$]);
      }
      if (l.mark) {
        c = l.mark;
        const $ = Object.entries(l.mark);
        t.update(v, (M) => [...M, ...$]);
      }
    }
    await t.wait(m);
    const u = t.get(h), d = Object.keys(o).map((l) => [l, u.nodes[l]]), w = Object.keys(c).map((l) => [l, u.marks[l]]);
    return Object.fromEntries([
      ...d,
      ...w
    ]);
  }, e), r.view) {
    const o = r.view(t), c = Object.entries(o).filter(([d]) => t.get(C).findIndex((w) => w[0] === d) !== -1), u = Object.entries(o).filter(([d]) => t.get(v).findIndex((w) => w[0] === d) !== -1);
    t.update(S, (d) => [...d, ...c]), t.update(A, (d) => [...d, ...u]);
  }
})), re);
function be(a, n) {
  return (e) => e.get(g).call(a, n);
}
const Pe = () => (a) => a.get(p).destroy(), Ee = () => (a) => {
  const n = a.get(p), { tr: e } = n.state, s = Object.assign(Object.create(e), e).setTime(Date.now());
  return n.dispatch(s);
}, Ie = () => (a) => {
  const n = document.createElement("div"), e = a.get(h), s = a.get(p), t = x.fromSchema(e).serializeFragment(s.state.doc.content);
  return n.appendChild(t), n.innerHTML;
}, ze = () => (a) => {
  const n = a.get(p);
  return a.get(Y)(n.state.doc);
}, Ve = (a) => (n) => {
  const e = n.get(p), t = n.get(K)(a);
  if (!t)
    return;
  const i = e.state.selection.content();
  return e.dispatch(e.state.tr.replaceSelection(new B(t.content, i.openStart, i.openEnd)).scrollIntoView());
}, je = () => (a) => {
  const n = a.get(p), e = [];
  return n.state.doc.descendants((t) => {
    t.type.name === "heading" && t.attrs.level && e.push({ text: t.textContent, level: t.attrs.level, id: t.attrs.id });
  }), e;
}, Le = (a, n = !1) => (e) => {
  const s = e.get(p), i = e.get(K)(a);
  if (!i)
    return;
  if (!n) {
    const { state: w } = s;
    return s.dispatch(w.tr.replace(0, w.doc.content.size, new B(i.content, 0, 0)));
  }
  const r = e.get(h), o = e.get(Z), c = e.get(f), u = e.get(I), d = ee.create({
    schema: r,
    doc: i,
    plugins: c,
    ...o
  });
  s.updateState(d), u.flush(e);
}, Ne = (a, n) => (e) => {
  const s = e.get(p), { tr: t } = s.state, i = t.doc.nodeAt(a);
  if (!i)
    return;
  const r = n(i.attrs);
  return s.dispatch(t.setNodeMarkup(a, void 0, r));
}, De = (a) => (n) => n.get(I).switch(n, a);
export {
  we as $command,
  le as $commandAsync,
  he as $inputRule,
  pe as $inputRuleAsync,
  ye as $mark,
  ge as $markAsync,
  fe as $node,
  ke as $nodeAsync,
  ve as $prose,
  Ce as $proseAsync,
  Te as $remark,
  Se as $remarkAsync,
  Ae as $shortcut,
  $e as $shortcutAsync,
  Me as $view,
  Oe as $viewAsync,
  G as AtomList,
  D as addMetadata,
  N as applyMethods,
  be as callCommand,
  ae as createMark,
  se as createNode,
  re as createPlugin,
  Re as createShortcut,
  Pe as destroy,
  Ee as forceUpdate,
  ne as getClassName,
  Ie as getHTML,
  ze as getMarkdown,
  L as getUtils,
  Ve as insert,
  je as outline,
  Le as replaceAll,
  Ne as setAttr,
  De as switchTheme,
  H as withExtend
};
//# sourceMappingURL=index.es.js.map
